import Vue from 'vue'
import VueI18n from "vue-i18n";
import zhCN from './zh-CN.json'
import en from './en.json'
import dan from './dan.json'
import el from './el.json'
import fra from './fra.json'
import it from './it.json'
import jp from './jp.json'
import pt from './pt.json'
import spa from './spa.json'
import vie from './vie.json'
import de from './de.json'
// import mx from './mx.json'
// import nor from './nor.json'
Vue.use(VueI18n)
const messages = {
  'zh-CN': {
    ...zhCN
  },
  'en': {
    ...en
  },
  dan,
  el,
  fra,
  it,
  jp,
  pt,
  spa,
  vie,
  de,
  // mx,
  // nor
}
const i18n = new VueI18n ({
    legacy: false,
    messages,
    locale: sessionStorage.getItem('lang') || 'en'
})

export default i18n


// WEBPACK FOOTER //
// ./src/locales/index.js